<template>
  <div id="app" :class="[isMobile ? 'appM':'appPc', {'loginbg':$route.name == 'login'}]">
    <h1 class="title" id="title" style="display:none;">网易云游戏</h1>
    <router-view></router-view>
  </div>
</template>

<script>
import _ from '@/utils/util'
export default {
  name: 'App',
  data(){
    return{
      isMobile:_.isMobile(),
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
